import React from 'react';
import bannerBg from '../assets/img/page-banner.jpg';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';
import PageBanner from '../components/PageBanner';
import productsData from '../components/data/products';
// import { Link } from 'react-router-dom';
import Blog3 from '../components/Blog3';
import Cta from '../components/Cta';
import categoriesData from '../components/data/categories';

function Products() {
  const categories = [];
  const map = new Map();

  for (const item of productsData) {
    if (!map.has(item.category)) {
      map.set(item.category, true);
      categories.push({
        id: item.id,
        category: item.category,
        // Change 'thumbnail: item.thumbnail' to 'thumbnail: item.Image'
        thumbnail: item.Image,
        title: `${item.category.replace(/-/g, " ")} Products`,
        meta: "Category",
      });
    }
  }

  return (
    <>
      <Header1 />
      <PageBanner
        bannerBg={bannerBg}
        currentPage="Products"
        heading="What We Offer"
      />
      {/* <div className="container">
                    <div className="row">
                        {categories.map((cat, idx) => (
                            <div className="col-xl-4 col-md-6 col-12" key={idx}>
                                <div className="single-news-card">
                                    <div
                                        className="featured-thumb bg-cover"
                                        style={{ backgroundImage: `url(${cat.thumbnail})` }}
                                    />
                                    <div className="post-content" style={{padding: '30px', background: '#fff', border: '1px solid #eee', marginTop: '-30px', position: 'relative', zIndex: 2, margin: '0 20px', borderRadius: '5px'}}>
                                        <h3 style={{textTransform: 'capitalize'}}>
                                            <Link to={`/products/${cat.category}`}>
                                                {cat.category}
                                            </Link>
                                        </h3>
                                        <Link
                                            className="read-btn"
                                            to={`/products/${cat.category}`}
                                            style={{color: '#ff5e14', fontWeight: 600, display: 'inline-block', marginTop: '15px'}}
                                        >
                                            View Products
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div> */}

      <Blog3 productsData={categoriesData} />
      <Cta />
      <Footer1 />
    </>
  );
}

export default Products;
